import { useContext } from 'react'
import { useAsyncFn } from 'react-use'
import { config } from '../../../config'
import { ContextShell } from '../../../modules/context'
import { Moises } from '../../../lib/cli'

interface UseEbanxAutoRenew {
  loading: boolean
  error?: Error | undefined
  value?: boolean
  toggleAutoRenew(): Promise<boolean | void>
}

const MoisesCLI = Moises({ apiEndpoint: config.api.endpoint })

export const useEbanxAutoRenew = (): UseEbanxAutoRenew => {
  const { userToken, silentRetry } = useContext(ContextShell)

  const [state, toggleAutoRenew] = useAsyncFn(async () => {
    if (!userToken) return false

    MoisesCLI.auth(userToken)
    await MoisesCLI.toggleAutoRenewSubscription()

    silentRetry()

    return true
  }, [userToken, silentRetry])

  return {
    ...state,
    toggleAutoRenew
  }
}
